<template>
  <basic-container>
    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <div class="project-title">
            {{basicInfoData.name}}
          </div>

          <div class="project-status">
            <CommonDetail
              textAlign="left"
              :configArray="formConfig"
              :initValue="basicInfoData"
              :showNull="false"
            />
            <div class="status_wrapper">
              <div class="status-title">收尾状态</div>
              <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditState]">
                {{basicInfoData.auditStateStr}}
              </div>
            </div>

          </div>

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane class="activelabel" label="附件信息" name="first">
                <div class="informationxm blue-avue-form">
                  <Accessory
                    topTableName=""
                    idname="收尾管理"
                    :upload="basicInfoData.auditStatus == 0&&basicInfoData.managerUser == userInfo.user_id"
                    :projectid="basicInfoData.projectInfoId?basicInfoData.projectInfoId:basicInfoData.id"
                    :projectname='data.name'
                    :dynamicId="id"
                    :packagedownload='basicInfoData.closeState == 3?true:false'
                  />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <div>
  
        <Dialog :data="data" ref="dialogpass" />
        <Dialogreason
          :passdata="passData"
          @passcheck="passcheck"
          ref="reasondialog"
        />
      </div>
    </div>

    <div class="bottom-container" v-if="basicInfoData.auditState != 2">
      <div class="button-container">
        <!-- <el-button type="primary" @click="validData(false)">保存</el-button> -->
        <el-button v-if="basicInfoData.auditState == 0" type="primary" plain @click="updatastate()" >收尾</el-button>
        <div class="button-container" v-if="basicInfoData.auditState == 1 && permission.zg_project_conclusion_audit">
          <el-button
            type="primary"
            icon="el-icon-check"
            plain
            @click="auditNext(basicInfoData.id, true)"
          >
            通过
          </el-button>
          <el-button
            type="warning"
            icon="el-icon-close"
            plain
            @click="auditNext(basicInfoData.id, false)"
          >
            退回
          </el-button>
      </div>
      </div>
    </div>

    <!-- <BottomLine
      v-else
      ref="bottomLine"
      :auditState="basicInfoData.auditStatus"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess"
      :buildNew="buildNew"
      @buildNewOne="buildNewOne"
      @startProcess="saveProject('startProcess')"
      @saveTask="saveTask"
      @saveProject="saveProject"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    /> -->
  </basic-container>
</template>

<script>
// import Usermanage from "./components/usermanage.vue";
import Accessory from "@/components/accessoriesother/accessoryFactor";
import CommonDetail from "@/components/commonDetail/commonDetail";
import { getFundCloseDetail, addFundClose, submitaudit, auditZgbasicinfo } from "@/api/zg/zg";
import Dialog from "@/components/detail/rzzl_lxj/dialog";
import Dialogreason from "./components/reason";
import { formConfig } from "./config"
// import Details from "@/components/detail/projectconclusiondetail";
// import Detaillist from "@/components/detail/detaillist";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
export default {
  name: "bankmanageDetail",
  mixins: [workFlow],
  data() {
    return {
      basicInfoData: {},
      formConfig: formConfig(),
      activeName: "first",
      processKey: 'process_loan_finish',
      detailFormUrl: '/zg/fund/projectconclusion/detail',       
      data: {},
      passblock: false,
      passData: {
        id: "",
        advise: "",
        pass: false
      },
      auditstateName: "",
      butshengheloading: false,
      but_shenghe: false,
      statetitle: "",
      butstatetitle: "",
      bankStateName: "",
      examine: true,
      wf_state: [],
      audit_state: [],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dialogVisible: false,

      option0: {
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "原因描述",
            prop: "advise",
            type: "textarea",
            minRows: 4,
            maxlength: 200,
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入原因",
                trigger: "blur"
              }
            ]
          }
        ]
      },
       detaildeta: {
        edit: "false",
        add: "permission.close_add",
        audit: "permission.close_audit",
        title: "data.name ",
      },
      detaillist: {
        column: [
           {
            label: "项目编号",
            prop: "number",
          },
           {
            label: "客户名称",
            prop: "custName",
          },
           {
            label: "申请银行",
            prop: "bankName",
          },
           {
            label: "申请转贷金额",
            prop: "quota",
            formatter:()=>{
              return this.getMoney(this.data.quota) +" 元";
            }
          },
           {
            label: "使用费率",
            prop: "loanRate ",
            formatter:()=>{
              return this.data.loanRate*100+"%"
            }
          },
          {
            label: "客户经理",
            prop: "managerName ",
          },
        ],
        showcolumn:[
                {
            label: "收尾状态",
            prop: "closeState",
            show: "pageData.closeState>=1",
            auditlog: true,
            state: 0,
            // state ：0  前面是否加上小圆点
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=close_state",
          },
        ],
             firstsblock: {
          formatter: () => {
           return this.data.wfStatus == 2 && this.data.auditState >= "1" ? 20 : 19;
          },
        },
        sentersblock: {
          formatter: () => {
             return this.data.wfStatus == 2 && this.data.auditState >= "1" ?4 : 5
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "40%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        }
    };
  },
  components: { 
    // Usermanage,
    Accessory,
    // Details,
    // Detaillist,
    CommonDetail,
    Dialog,
    Dialogreason
  },
  watch: {
    $route: {
      handler() {
        let id = this.$route.params.id;
        this.onLoad(id);
      },
      deep: true
    }
  },
  created() {
    this.onLoad(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    firstsblock(){
      return this.data.closeState == 1?6:7
    },
    sentersblock(){
      return this.data.closeState == 1?8:10
    },
    lastsblock(){
      return this.data.closeState == 1?7:7

    },
    leftsblock(){
      return this.data.wfStatus==2&&this.data.auditState >='1'?21:19

    },
    rightsblock(){
      return this.data.closeState == 1?3:0

    }

  },
  methods: {
    // getwf_state() {
    //   api.wf_state().then(res => {
    //     this.wf_state = res.data.data;
    //   });
    // },
    // getaudit() {
    //   api.audit_state().then(res => {
    //     this.audit_state = res.data.data;
    //   });
    // },
    // bankstate(data) {
    //   api.bankstate().then(res => {
    //     let vals = res.data.data.findIndex(val => val.dictKey == data);
    //     this.bankStateName = res.data.data[vals].dictValue;
    //   });
    // },

    // 通过
    quanxian(id, type) {
      // this.passblock = true;
      // this.passtype=type
      this.passData.id = id;
      this.$refs.reasondialog.showblock(type);
    },
    //确定通过或退回
    passcheck(data, type) {
      let self = this;
      let params = {
        auditAdvise: data.advise,
        auditState: type == "true" ? 2 : 3,
        pass: type == "true" ? true : false,
        id: this.basicInfoData.id,
      };
      auditZgbasicinfo(params).then((res) => {
        self.onLoad(self.basicInfoData.id);
        self.$message({
          type: "success",
          message: res["data"]["msg"],
        });
      });
    },
    onLoad(id) {
      getFundCloseDetail({ id: id }).then(res => {         
          // this.getauditstate(res.data.data);
          // this.bankstate(res.data.data.bankState);
          this.basicInfoData = res.data.data;
          // this.data.wfStatus = res.data.data.wfStatus.toString();
          // this.data.auditLog = JSON.parse(res.data.data.auditLog);
          // this.data.contractTerms = res.data.data.contractTerms.slice(0, 11);
        })
        .catch(res => {
           
        });
    },
    warningblock() {
      this.$refs.dialogpass.showblock();
    },

    auditNext(id, type) {
      this.$data.passData.id = id;
      this.$refs.reasondialog.showblock(`${type}`);
    },


    updatastate() {
      this.$confirm("是否确定提交收尾?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        this.butshengheloading = true;
        submitaudit(this.basicInfoData.id)
          .then(res => {
              
            this.$message({
              type: "success",
              message: res.data.msg
            });
            this.onLoad(this.$route.params.id);
          })
          .catch(res => {
              
          });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },

    async submitForm() {
      let params = {
        id: this.id,
        flowableId: '',
        ...this.basicInfoData
      }
      let res = await addFundClose(params)
      if(res.data.code == 200){
        this.onLoad(this.$route.params.id)
      }
    },

    // 保存尽调数据
    async saveTask() {
      let taskId = this.processDetail.process.taskId;
      // 从vuex中获取
      let comment = this.workFlowData.opinionContent;
      // let attachmentList = this.workFlowData.attchmentList

      // 流程表单数据
      let customData = this.$refs.auditInfo.commentDetail;
      let formData = this.$refs.auditInfo.$data.formData;

      let variables = this.dealAuditForm(formData, customData);
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment;
      // variables[`attachment_${taskId}`] = attachmentList

      let saveRes = await this.flowSaveTask(variables);
      // 刷新数据
      this.saveTask = {
        comment: "",
        attachment: [],
      };
      this.onLoad(this.id);
      this.$forceUpdate();
    },

    // 流程流转
    async flowNext(taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName;
      // let valid = false;
      // 流程表单数据
      // if (
      //   this.$refs.auditInfo.avueFormConfig.column &&
      //   this.$refs.auditInfo.avueFormConfig.column.length > 0
      // ) {
      //   valid = this.$refs.auditInfo.validData();
      // } else {
      //   valid = true;
      // }
      // if (valid) {
        // let customData = this.$refs.auditInfo.commentDetail;
        // let formData = this.$refs.auditInfo.$data.formData;

        // let variables = this.dealAuditForm(formData, customData);
        if (taskInfoList) {
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            // variables,
            JSON.stringify(taskInfoList)
          );
        } else {
          let res = await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            // variables
          );
        }

        // 刷新数据
        this.onLoad(this.id);
        this.$forceUpdate();
      // }
    },    
  }
};
</script>

<style lang="scss" scoped>
/deep/ .item-label{
  min-width: 100px !important;
}
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 30px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    z-index: 20;
    flex-direction: row;

    .history_content {
      width: 110px;
      cursor: pointer;
      height: 45px;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      text-align: right;
      padding-right: 15px;
      border-radius: 5px 0 0 5px;
    }
  }
  .banktail_ {
    // width: 1000px;
    width: 92%;
    margin: 0 auto;
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .project-status{
      justify-content: space-between;
      .status-title{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
    .stateTopdiv::before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .color_0::before {
      background: #fec03d;
    }
    .color_1::before {
      background: #409eff;
    }
    .color_2::before {
      background: #51d351;
    }
    .color_3::before {
      background: #F56C6C;
    }
    .color_4::before {
      background: #F56C6C;
    }
  }
  .project-status{
    display: flex;
    .status_wrapper {
      width: 200px;
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
        padding-top: 20px;
      }
    }
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 15px;
      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        .list_top {
          flex: 1;
        }
        .topone {
          flex: 1.5;
        }
        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #51d351;
}

.flagBook_0:before {
  background: #fec03d;
}
.flagBook_1:before {
  background: #fec03d;
}
.flagBook_2:before {
  background: #fec03d;
}
.flagBook_3:before {
  background: #90cb31;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}

.box_cards {
  height: 450px;
  overflow-y: auto;
}
.passblocksblock {
  // margin-top: 25px;
  text-align: right;
}
/deep/.el-tabs__header{
  margin: 0px;
}
/deep/.el-form-item{
  margin-bottom: 0px;
}
/deep/.el-form-item__label{
  color: #999999;
}
.bottom-container{
  width: 100%;
  height: 70px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
  .button-container{
    width: 92%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
/deep/.el-tabs__content {
  margin-bottom: 60px;
}
</style>
<style>
.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
</style>
